import React, { useState } from "react"
import styled from "styled-components"
import logo from "../../images/logo/logoShadow.svg"
import { reasons } from "../../data/reasons"

const List = styled.ul`
  display: flex;
  flex-direction: column;
  margin-top: 32px;
  @media (min-width: 768px) {
    position: relative;
    width: 700px;
    height: 700px;
    margin: 0 auto;
    z-index: 10;
  }
  @media (min-width: 1024px) {
    width: 770px;
    height: 770px;
  }
`

const Element = styled.li`
  display: flex;
  align-items: center;
  margin-bottom: 32px;
  cursor: pointer;
  transition: 0.2s ease;
  & div {
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    width: 32px;
    height: 32px;
  }
  & p {
    margin-left: 12px;
    font-family: "Made Medium", sans-serif;
    font-size: 20px;
    letter-spacing: 0.3px;
  }

  @media (min-width: 768px) {
    position: absolute;
    flex-direction: column;
    margin-bottom: 0;
    height: 76px;
    & p {
      margin-left: 0;
      margin-top: 8px;
    }
    &:nth-child(7) {
      top: 0;
      left: 15%;
      transform: translateX(-25%);
      &:hover {
        transform: scale(1.06) translateX(-25%);
      }
    }
    &:nth-child(8) {
      top: 25%;
      left: 0;
      transform: translateY(-50%);
      &:hover {
        transform: scale(1.06) translateY(-50%);
      }
    }
    &:nth-child(9) {
      top: 50%;
      left: 15%;
      transform: translate(-25%, -100%);
      &:hover {
        transform: scale(1.06) translate(-25%, -100%);
      }
    }
    &:nth-child(10) {
      top: 0;
      right: 15%;
      transform: translateX(25%);
      &:hover {
        transform: scale(1.06) translateX(25%);
      }
    }
    &:nth-child(11) {
      top: 25%;
      right: 0;
      transform: translateY(-50%);
      &:hover {
        transform: scale(1.06) translateY(-50%);
      }
    }
    &:nth-child(12) {
      top: 50%;
      right: 15%;
      transform: translate(25%, -100%);
      &:hover {
        transform: scale(1.06) translate(25%, -100%);
      }
    }
  }
`

const Card = styled.li`
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 12px 18px 0 rgba(0, 0, 0, 0.05), 0 4px 6px 0 rgba(0, 0, 0, 0.1);
  position: absolute;
  top: 25%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 220px;
  opacity: 0;
  transition: 0.2s ease;
  background-color: #fff;
  display: none;
  &.active {
    opacity: 1;
  }
  & img {
    width: 40px;
    height: 40px;
    margin-bottom: 10px;
  }
  & p {
    font-size: 16px;
    font-family: "Made Light", sans-serif;
    line-height: 24px;
    letter-spacing: 0.2px;
    text-align: center;
    @media (min-width: 1024px) {
      font-size: 20px;
      line-height: 32px;
    }
  }
  @media (min-width: 768px) {
    display: flex;
  }
  @media (min-width: 1024px) {
    max-width: 270px;
  }
`

const data = [
  "analizyjemy produkty sklepy etc.",
  "Wykorzystujemy najnowsze technologie, takie jak react i gatsby.",
  "optymalizyjemy koszty jak i produkt - szybko i dobrze",
  "Realizujemy pracę mozliwie jak naszybciej, zawsze w zgodzie z klientem",
  "Cenimy produkty indywidualne - wiemy, ze będą specjalnie dla Ciebie",
  "Znamy trendy, jak i na bieząco je śledzimy",
]

const ListOfReasons = () => {
  const [activeCard, setActiveCard] = useState(1)
  return (
    <List>
      {reasons.map(({ desc }, i) => (
        <Card className={activeCard === i && "active"} key={desc}>
          <img src={logo} alt="Dbamy o owocną współpracę" title="logo" />
          <p>{desc}</p>
        </Card>
      ))}
      {reasons.map(({ title, icon }, i) => (
        <Element
          onMouseEnter={() => setActiveCard(i)}
          onMouseLeave={() => setActiveCard(null)}
          key={title}
        >
          <div style={{ backgroundImage: `url(${icon})` }} />
          <p>{title}</p>
        </Element>
      ))}
    </List>
  )
}

export default ListOfReasons
